import AuthHeader from './components/AuthHeader';
import GuestHeader from './components/GuestHeader';

export interface IHeaderProps {
    /** Показывать хэдер для авторизованного пользователя или нет */
    isAuth: boolean;
    className?: string;
}

const Header: React.FC<IHeaderProps> = ({ isAuth, className }) =>
    isAuth ? <AuthHeader className={className} /> : <GuestHeader className={className} />;

export default Header;
